export default "<div  [attr.id]=\"elementId\" [ngStyle]=\"style\"></div>\n"